import cx from 'classnames';
import React from 'react';

import s from './Loader.css';

type Props = {
    className?: string;
    dataTestId?: string;
    color?: string;
};

export const Loader = ({ className, dataTestId, color }: Props): JSX.Element => (
    <div
        className={cx(s.spinner, className)}
        data-testid={['loader', dataTestId].join(' ')}
        style={color ? ({ '--loader-color': color } as React.CSSProperties) : undefined}
    >
        {[1, 2, 3].map((i) => (
            <div key={i} className={cx(s[`bounce${i}`], s.animated)} />
        ))}
    </div>
);
